import { Link } from 'react-router';
import { Facebook, Twitter, Instagram, Linkedin, Phone, Mail, MapPin } from 'lucide-react';
import { useSettings } from '../contexts/SettingsContext';

export function Footer() {
  const { settings } = useSettings();
  
  return (
    <footer className="bg-[#8B7109] text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid md:grid-cols-4 gap-8">
          {/* About Section */}
          <div>
            {settings.logo ? (
              <img src={settings.logo} alt={settings.siteNameArabic} className="h-12 mb-4 object-contain brightness-0 invert" />
            ) : (
              <div className="text-2xl font-bold mb-4">
                <span className="text-[#FFE5A0]">دار</span> العقار
              </div>
            )}
            <p className="text-gray-100 text-sm leading-relaxed mb-4">
              {settings.description || 'منصة عقارية رائدة في المنطقة تقدم أفضل الخيارات للبيع والإيجار. نساعدك في إيجاد منزل أحلامك بكل سهولة وأمان.'}
            </p>
            <div className="flex gap-3">
              {settings.facebookUrl && (
                <a href={settings.facebookUrl} target="_blank" rel="noopener noreferrer" className="w-8 h-8 bg-[#D4AF37] hover:bg-[#FFE5A0] hover:text-[#8B7109] rounded-full flex items-center justify-center transition-colors">
                  <Facebook className="w-4 h-4" />
                </a>
              )}
              {settings.twitterUrl && (
                <a href={settings.twitterUrl} target="_blank" rel="noopener noreferrer" className="w-8 h-8 bg-[#D4AF37] hover:bg-[#FFE5A0] hover:text-[#8B7109] rounded-full flex items-center justify-center transition-colors">
                  <Twitter className="w-4 h-4" />
                </a>
              )}
              {settings.instagramUrl && (
                <a href={settings.instagramUrl} target="_blank" rel="noopener noreferrer" className="w-8 h-8 bg-[#D4AF37] hover:bg-[#FFE5A0] hover:text-[#8B7109] rounded-full flex items-center justify-center transition-colors">
                  <Instagram className="w-4 h-4" />
                </a>
              )}
              {settings.linkedinUrl && (
                <a href={settings.linkedinUrl} target="_blank" rel="noopener noreferrer" className="w-8 h-8 bg-[#D4AF37] hover:bg-[#FFE5A0] hover:text-[#8B7109] rounded-full flex items-center justify-center transition-colors">
                  <Linkedin className="w-4 h-4" />
                </a>
              )}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-bold text-lg mb-4">روابط سريعة</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-100 hover:text-[#FFE5A0] transition-colors text-sm">
                  الرئيسية
                </Link>
              </li>
              <li>
                <Link to="/properties" className="text-gray-100 hover:text-[#FFE5A0] transition-colors text-sm">
                  العقارات
                </Link>
              </li>
              <li>
                <Link to="/properties?type=sale" className="text-gray-100 hover:text-[#FFE5A0] transition-colors text-sm">
                  عقارات للبيع
                </Link>
              </li>
              <li>
                <Link to="/properties?type=rent" className="text-gray-100 hover:text-[#FFE5A0] transition-colors text-sm">
                  عقارات للإيجار
                </Link>
              </li>
              <li>
                <Link to="#" className="text-gray-100 hover:text-[#FFE5A0] transition-colors text-sm">
                  من نحن
                </Link>
              </li>
              <li>
                <Link to="#" className="text-gray-100 hover:text-[#FFE5A0] transition-colors text-sm">
                  اتصل بنا
                </Link>
              </li>
            </ul>
          </div>

          {/* Property Types */}
          <div>
            <h3 className="font-bold text-lg mb-4">أنواع العقارات</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/properties?category=apartments" className="text-gray-100 hover:text-[#FFE5A0] transition-colors text-sm">
                  شقق
                </Link>
              </li>
              <li>
                <Link to="/properties?category=villas" className="text-gray-100 hover:text-[#FFE5A0] transition-colors text-sm">
                  فلل
                </Link>
              </li>
              <li>
                <Link to="/properties?category=offices" className="text-gray-100 hover:text-[#FFE5A0] transition-colors text-sm">
                  مكاتب
                </Link>
              </li>
              <li>
                <Link to="/properties?category=commercial" className="text-gray-100 hover:text-[#FFE5A0] transition-colors text-sm">
                  محلات تجارية
                </Link>
              </li>
              <li>
                <Link to="/properties?category=bungalow" className="text-gray-100 hover:text-[#FFE5A0] transition-colors text-sm">
                  بنغل
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="font-bold text-lg mb-4">معلومات التواصل</h3>
            <ul className="space-y-3">
              <li className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-[#FFE5A0] flex-shrink-0 mt-1" />
                <span className="text-gray-100 text-sm">
                  {settings.address || 'القاهرة، مصر'}
                </span>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="w-5 h-5 text-[#FFE5A0] flex-shrink-0" />
                <a href={`tel:${settings.phone}`} className="text-gray-100 hover:text-[#FFE5A0] transition-colors text-sm">
                  {settings.phone}
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="w-5 h-5 text-[#FFE5A0] flex-shrink-0" />
                <a href={`mailto:${settings.email}`} className="text-gray-100 hover:text-[#FFE5A0] transition-colors text-sm">
                  {settings.email}
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-[#9A7B4F] mt-8 pt-6 text-center">
          <p className="text-gray-100 text-sm">
            © 2026 {settings.siteNameArabic}. جميع الحقوق محفوظة.
          </p>
        </div>
      </div>
    </footer>
  );
}